module.exports = __webpack_public_path__ + "media/images/homes/pos-fb-205cb7739b8af9ce384aaa8064f1424d.png";